import React from "react";
import Header from "../components/widgets/header";

export function TopHeader() {
  return (
    <div>
      <Header />
    </div>
  );
}

export default TopHeader;
